export type BlockStatus = 'empty' | 'short' | 'good'

/** Cheap heuristic for the card's status dot. */
export function blockStatus(content: string): BlockStatus {
  const t = content.trim()
  if (!t) return 'empty'
  if (t.length < 40) return 'short'
  return 'good'
}

/**
 * Rough client-side token estimate (chars / 4). This is a local
 * approximation only — it intentionally does NOT match the backend's
 * `estimate_tokens`, which uses a real tiktoken tokenizer. The browser
 * has no tokenizer available, so this card-status heuristic and the
 * composed-prompt inspector's backend-sourced counts can legitimately
 * disagree for the same block.
 */
export function estimateBlockTokens(content: string): number {
  return Math.max(0, Math.round(content.length / 4))
}
